import React from 'react';
import {AddressProps} from 'modules/addresses/types';
import {MediumText, RegularText} from 'shared/components/text';
import useCart from '../util/use-cart';
import {IoLocationOutline} from 'react-icons/io5';
import formatAddress from 'modules/addresses/util/format-address';
import styled from 'styled-components';
import {useNavigate} from 'react-router-dom';

const CartUserAddress: React.FC<AddressProps> = (address) => {
  const {cart, setAddress} = useCart();
  const navigate = useNavigate();

  const handleAddAddress = () => {
    setAddress({
      ...address,
      city: address.city.name,
      cityId: address.cityId,
      neighborhood: address.neighborhood.name,
      state: address.state,
    });
    navigate(-1);
  };

  return (
    <>
      <Container
        {...{active: cart?.address?.id === address.id}}
        onClick={handleAddAddress}>
        <IoLocationOutline />
        <Info>
          <MediumText style={{width: '70%'}}>
            {`${address.street}, ${address.number}`}
          </MediumText>
          <RegularText size="small">{formatAddress(address)}</RegularText>
        </Info>
      </Container>
    </>
  );
};

export default CartUserAddress;

interface ContainerProps {
  active?: boolean;
}

export const Container = styled.button<ContainerProps>`
  background-color: white;
  display: flex;
  flex-direction: row;
  padding: 20px 10px;
  gap: 10px;
  align-items: center;
  border-radius: 6px;
  border: 1px solid
    ${({active, theme}) => (active ? theme.colors.primary : '#ddd')};
  cursor: pointer;

  @media (min-width: 768px) {
    padding: 20px 20px;
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
